import { useLayoutEffect, useState } from "react";

import { useSearchParams } from "react-router-dom";

import { THeartRate } from "../../../@types";
import { calculateWind, normalizeGpsData } from "../../../utils";
import { TLocation } from "../Student/FlightLogs/FlightLogs";
import { ThreeDMapCesium } from "./ThreeDMapCesium";

import "./three_d_map.scss";

export function ThreeDMap() {
	const [searchParams] = useSearchParams();
	type TState = {
		isPremium: boolean;
		gpsData: TLocation[];
		heartRates: THeartRate[] | null;
	};
	const [state, setState] = useState<TState>({
		isPremium: false,
		gpsData: [],
		heartRates: null,
	});

	const colorScheme = searchParams.get("color");

	useLayoutEffect(() => {
		const handleMessage = (event: any) => {
			let data: TLocation[] = normalizeGpsData(event.detail.gpsData);
			let metarWind: { speed: number; direction: number } | null = null;
			if (event.detail.weather && typeof event.detail.weather === "string") {
				const weather: {
					wind: {
						speed: { value: number; unit: string };
						direction: { value: number; unit: string };
					};
				} = JSON.parse(event.detail.weather);
				metarWind = {
					speed: weather.wind.speed.value,
					direction: weather.wind.direction.value,
				};
			} else {
				const weather: {
					wind: {
						speed: { value: number; unit: string };
						direction: { value: number; unit: string };
					};
				} = event.detail.weather;
				metarWind = {
					speed: weather.wind.speed.value,
					direction: weather.wind.direction.value,
				};
			}
			const heartRates: THeartRate[] | null = event.detail.heartRates;
			data = calculateWind(data, metarWind).enhancedGPSData as TLocation[];
			const isPremium = event.detail.isPremium;

			setState((prevState) => ({
				...prevState,
				gpsData: data,
				isPremium,
				heartRates,
			}));
		};
		window.addEventListener("receivegpsdata", handleMessage);

		return () => {
			window.removeEventListener("receivegpsdata", handleMessage);
		};
	}, [colorScheme]);

	if (state.gpsData.length === 0) {
		return null;
	}

	return (
		<ThreeDMapCesium
			gpsData={state.gpsData}
			isPremium={state.isPremium}
			heartRates={state.heartRates}
		/>
	);
}
